import {watch, toRaw, computed, ref} from "vue";
import {useAdsStore} from "@/stores/ads";
import {useSectionsStore} from "@/stores/section";
import {storeToRefs} from "pinia";

export const useAds = () => {
    const adsStore = useAdsStore()
    const { ads, setActiveScreening } = storeToRefs(adsStore)
    const getAds = computed(() => ads.value)
    const sectionsStore = useSectionsStore()
    const { pageSettings } = storeToRefs(sectionsStore)
    const pageType = computed(() => pageSettings.value?.type)
	const pageId = computed(() => pageSettings.value?.id)

	if (pageId === 88934801) { return }

    let adsDesktop = ref(null)
    let adsMobile = ref(null)
    let master = ref({})
    let isSraSend = ref(false)
    let type = pageType.value;
    const googletag = window.googletag

    const gam = {
        desktop: {},
        mobile: {}
    };

    const adocean = {
        desktop: {},
        mobile: {}
    };

    let observerAdoBeetweenModules = null;
    let observerGamBeetweenModules = null;

    watch(getAds, (currentValue) => {
            type = pageType.value;

            if (currentValue && toRaw(currentValue) && (toRaw(currentValue).desktop || toRaw(currentValue).mobile)) {
                adsDesktop = toRaw(currentValue).desktop;
                adsMobile = toRaw(currentValue).mobile;

                if (observerAdoBeetweenModules) {
                    observerAdoBeetweenModules.disconnect();
                    observerAdoBeetweenModules = null;
                }
        
                if (observerGamBeetweenModules) {
                    observerGamBeetweenModules.disconnect();
                    observerGamBeetweenModules = null;
                }

                init();
            }
        },
        { immediate: true, deep: true }
    );

    const init = () => {
        isSraSend = false;

        if (getAds && getAds !== null) {
            master = {
                desktop:
                    (adsDesktop && adsDesktop.master && adsDesktop.master.id) ||
                    null,
                mobile:
                    (adsMobile && adsMobile.master && adsMobile.master.id) || null
            };

            if (adsDesktop) {
                Object.keys(adsDesktop).forEach(key => {
                    if (!adsDesktop[key]) delete adsDesktop[key];
                });
            }
            if (adsMobile) {
                Object.keys(adsMobile).forEach(key => {
                    if (!adsMobile[key]) delete adsMobile[key];
                });
            }

            // screeningDetect();
            clearAds();

            const interval = setInterval(() => {
                if (googletag && googletag.enums) {
                    clearInterval(interval);
                    gamInit();
                }
            }, 50);

            // jeśli mamy id mastera
            if ((adsDesktop && master.desktop) || (adsMobile && master.mobile)) {
                adoceanInit();
            }
        }
    }

    const screeningDetect = () => {
        if (document.querySelector('.screening')) {
            const callback = function(mutationsList) {
                if (document.querySelector('.screening').style.backgroundImage) {
                    document
                        .querySelector('.screening__wrapper')
                        .classList.add('active-yes');
                    document
                        .querySelector('.screening')
                        .classList.add('screening--active');

                    setTimeout(() => {
                        adsStore.setActiveScreening()
                    }, 300);
                }

                // setTimeout(() => {
                //     adsStore.setActiveScreening()
                // }, 300);

                observer.disconnect()
                // window.dispatchEvent(new Event('resize'));

                return mutationsList;
            };

            const observer = new MutationObserver(callback);
            observer.observe(document.querySelector('.screening'), {
                attributes: true,
                attributeFilter: ['style'],
                childList: true
            });
        }

        if (document.querySelector('.belkaexpand')) {
            const callback = function(mutationsList) {
                let nav = document.querySelector('.nav');
                if (nav) {
                    let navOffset = nav.getBoundingClientRect().top;
                
                    if (navOffset > 0) {
                        document.querySelector('.screening').style.backgroundPosition = `center ${navOffset}px`;
                    }
                }

                return mutationsList;
            };

            const observer = new MutationObserver(callback);
            observer.observe(document.querySelector('.belkaexpand'), {
                attributes: true,
                attributeFilter: ['style'],
                childList: true,
                subtree: true
            });
        }
    }

    const checkSlotIsDefined = (slotName, id) => {
        let definedSlots = window.googletag.pubads().getSlots();
    
        let slotIndexToClear = definedSlots.findIndex(function(item) {
            if (
                (item.getSlotId().getDomId() === slotName && item.getSlotId().getName() !== id) || 
                ((slotName === 'stickyad' || slotName === 'interstitial' ) && item.getSlotId().getName().toLowerCase().includes(slotName))
            ) 
                return true;
        });
    
        // jeśli slot został zdefinowany i ma inne id
        if (slotIndexToClear !== -1) {
            googletag.destroySlots([definedSlots[slotIndexToClear]])
            return true;
        } else {
            let slotIndexToRefresh = definedSlots.findIndex(function(item) {
                if (item.getSlotId().getDomId() === slotName && item.getSlotId().getName() === id) 
                    return true;
            });
    
            // jeśli slot został zdefinowany i ma to samo id
            if (slotIndexToRefresh !== -1) {
                googletag.pubads().refresh([definedSlots[slotIndexToRefresh]]);
                return false;
            } else {
                return true;
            }
        }
    }

    const gamInit = () => {
        // odfiltrowanie reklam desktopowych gam
        if (adsDesktop) {
            Object.keys(adsDesktop).forEach(() => {
                gam.desktop = Object.keys(adsDesktop)
                    .filter(
                        key =>
                            adsDesktop[key].source &&
                            adsDesktop[key].source === 'gam'
                    )
                    .reduce((obj, key) => {
                        return Object.assign(obj, {
                            [key]: adsDesktop[key]
                        });
                    }, {});
            });

            templateMessage();
        }

        // odfiltrowanie reklam mobilnych gam
        if (adsMobile) {
            Object.keys(adsMobile).forEach(() => {
                gam.mobile = Object.keys(adsMobile)
                    .filter(
                        key =>
                            adsMobile[key].source && adsMobile[key].source === 'gam'
                    )
                    .reduce((obj, key) => {
                        return Object.assign(obj, {
                            [key]: adsMobile[key]
                        });
                    }, {});
            });
        }

        if (window.innerWidth >= 992 && Object.keys(gam.desktop).length) {
            // załaduj reklamy desktopowych gam
            initGamSlots(gam.desktop);
            betweenGamModulesWatch(gam.desktop);
        }

        if (window.innerWidth < 992 && Object.keys(gam.mobile).length) {
            // załaduj reklamy mobilne gam
            initGamSlots(gam.mobile);
            betweenGamModulesWatch(gam.mobile);
        }

        googletag.pubads().addEventListener('slotOnload', event => {
            const slot = event.slot;
            const slotName = slot.getSlotElementId();
            if (!slotName.includes('/') && slotName !== 'stickyad') {
                document.querySelector(`#${slotName}`).classList.add('loaded');
            }

            if (slotName === 'wallpaper') {
                document
                    .querySelector('.screening__wrapper')
                    .classList.add('active-yes');
                document
                    .querySelector('.screening')
                    .classList.add('screening--active');
            }

            if (slotName === 'stickyad') {
                document.querySelector('.stickyad__wrapper').classList.add('loaded');
            }

            if (slotName === 'interstitial') {
                document.querySelector('.interstitial__wrapper').classList.add('loaded');
            }

			if (slotName === 'brandingtop') {
				['.article__player-wrapper', '.video-page__player']
				.forEach(selector => {
					const el = document.querySelector(selector);
					if (el) el.classList.add('branding');
				});
            }
        });

        googletag.pubads().addEventListener('slotRenderEnded', function(event) {
            if (event && event.isEmpty) {
                const slot = event.slot;
                const slotName = slot.getSlotElementId();

                if (slotName === 'brandingtop') {
					// console.log(`slotRenderEnded ${slotName}`);
					['.article__player-wrapper', '.video-page__player']
					.forEach(selector => {
						const el = document.querySelector(selector);
						if (el) el.classList.remove('branding');
					});

                    videoWrapper.classList.remove('branding');

                    document
                        .querySelectorAll(
                            '.brandingtopspacer, .brandingbottomspacer'
                        )
                        .forEach(item => {
                            item.setAttribute('href', '');
                        });
                }
            }
        });
    }

    const initGamSlots = (adsData) => {
        let slotsArr = [];
        if (adsData['wallpaper'] && checkSlotIsDefined('wallpaper', adsData['wallpaper'].id)) {
            googletag.cmd.push(function() {
                googletag
                    .defineSlot(
                        adsData['wallpaper'].id,
                        adsData['wallpaper'].sizes,
                        'wallpaper'
                    )
                    .addService(googletag.pubads());
            });
            slotsArr.push('wallpaper');
        }

        if (adsData['belkaexpand']) {
            googletag.cmd.push(function() {
                googletag
                    .defineSlot(
                        adsData['belkaexpand'].id,
                        adsData['belkaexpand'].sizes,
                        'belkaexpand'
                    )
                    .addService(googletag.pubads());
            });
            slotsArr.push('belkaexpand');
        }

        if (adsData['stickyad'] && checkSlotIsDefined('stickyad', adsData['stickyad'].id)) {
			googletag.cmd.push(function() {
				googletag
					.defineSlot(
                        adsData['stickyad'].id,
                        adsData['stickyad'].sizes,
                        'stickyad'
					)
					.addService(googletag.companionAds())
					.addService(googletag.pubads());

				googletag
					.companionAds()
					.setRefreshUnfilledSlots(false);
				googletag.pubads().enableVideoAds();
			});

            slotsArr.push('stickyad');
        }

		// if (adsData['brandingtop'] && checkSlotIsDefined('brandingtop', adsData['brandingtop'].id)) {
		// 	googletag.cmd.push(function() {
		// 		googletag
		// 			.defineSlot(
        //                 adsData['brandingtop'].id,
        //                 adsData['brandingtop'].sizes,
        //                 'brandingtop'
		// 			)
		// 			.addService(googletag.companionAds())
		// 			.addService(googletag.pubads());

		// 		googletag
		// 			.companionAds()
		// 			.setRefreshUnfilledSlots(false);
		// 		googletag.pubads().enableVideoAds();
		// 	});

        //     slotsArr.push('brandingtop');
        // }

        if (adsData['interstitial'] && checkSlotIsDefined('interstitial', adsData['interstitial'].id)) {
            googletag.cmd.push(function() {
                googletag
                    .defineSlot(
                        adsData['interstitial'].id,
                        adsData['interstitial'].sizes,
                        'interstitial'
                    )
                    .addService(googletag.pubads());
            });
            slotsArr.push('interstitial');
        }

        if ((type !== 'SG' || (!adsData['slider1'] && !adsData['top'])) && slotsArr.length > 0) {
            googletag.pubads().enableSingleRequest();
            googletag.enableServices();
            googletag.display(slotsArr[0]);
        }
    }

    const betweenGamModules = (adsData) => {
        const top = document.querySelector('#top');
        const slider1 = document.querySelector('#slider1');
        const slider2 = document.querySelector('#slider2');
        const slider3 = document.querySelector('#slider3');
        const slider4 = document.querySelector('#slider4');
        const rectangle = document.querySelector('#rectangle');
        const brandingtop = document.querySelector('#brandingtop');
        // const brandingbottom = document.querySelector('#brandingbottom');

        if (top && adsData['top'] && !top.classList.contains('active-slot')) {
            initBetweenGamModulesSlot('top', adsData);
            top.classList.add('gam', 'active-slot');
        }
        if (slider1 && adsData['slider1'] && !slider1.classList.contains('active-slot')) {
            initBetweenGamModulesSlot('slider1', adsData);
            slider1.classList.add('gam', 'active-slot');
        }
        if (slider2 && adsData['slider2'] && !slider2.classList.contains('active-slot')) {
            initBetweenGamModulesSlot('slider2', adsData);
            slider2.classList.add('gam', 'active-slot');
        }
        if (slider3 && adsData['slider3'] && !slider3.classList.contains('active-slot')) {
            initBetweenGamModulesSlot('slider3', adsData);
            slider3.classList.add('gam', 'active-slot');
        }
        if (slider4 && adsData['slider4'] && !slider4.classList.contains('active-slot')) {
            initBetweenGamModulesSlot('slider4', adsData);
            slider4.classList.add('gam', 'active-slot');
        }
        if (rectangle && adsData['rectangle'] && !rectangle.classList.contains('active-slot')) {
            initBetweenGamModulesSlot('rectangle', adsData);
            rectangle.classList.add('gam', 'active-slot');
        }
        if (brandingtop && adsData['brandingtop'] && !brandingtop.classList.contains('active-slot')) {
            initBetweenGamModulesSlot('brandingtop', adsData);
            brandingtop.classList.add('gam', 'active-slot');
        }
        // if (brandingbottom && adsData['brandingbottom'] && !brandingbottom.classList.contains('active-slot')) {
        //     initBetweenGamModulesSlot('brandingbottom', adsData);
        //     brandingbottom.classList.add('gam', 'active-slot');
        // }
    }

    const betweenGamModulesWatch = (adsData) => {
        betweenGamModules(adsData)

        // wykrywanie załadowania międzymodułowych slotów i odpalanie reklam
        const callback = function(mutationsList) {
            betweenGamModules(adsData);

            return mutationsList;
        };

        observerGamBeetweenModules = new MutationObserver(callback);

        observerGamBeetweenModules.observe(document.querySelector('body'), {
            attributes: true,
            attributeFilter: ['style'],
            childList: true,
            subtree: true
        })
    }

    const initBetweenGamModulesSlot = (slotName, adsData) => {
        if (checkSlotIsDefined(slotName, adsData[slotName].id)) {
            let slot;

            googletag.cmd.push(function() {
                slot = googletag
                    .defineSlot(
                        adsData[slotName].id,
                        adsData[slotName].sizes,
                        slotName
                    )
                    .addService(googletag.pubads());

				if (slotName === 'brandingtop') {
					slot.addService(googletag.companionAds());
					googletag.companionAds().setRefreshUnfilledSlots(false);
					googletag.pubads().enableVideoAds();
				}

                if (type === 'SG' && adsData['slider1']) {
                    if (slotName === 'slider1') {
                        googletag.pubads().enableSingleRequest();
                        googletag.enableServices();
                        googletag.display(slot);
                        isSraSend = true;
                    } else if (isSraSend) {
                        googletag.enableServices();
                        googletag.display(slot);
                    }
                } else if (adsData['top']){
                    if (slotName === 'top') {
                        googletag.pubads().enableSingleRequest();
                        googletag.enableServices();
                        googletag.display(slot);
                        isSraSend = true;
                    } else if (isSraSend) {
                        googletag.enableServices();
                        googletag.display(slot);
                    }
                } else {
                    googletag.enableServices();
                    googletag.display(slot); 
                }
            });   
        }
    }

    const adoceanInit = () => {
        let ado = window.ado;

        if (typeof ado === 'undefined') {
            return;
        }

        if (typeof ado !== 'object') {
            ado = {};
            ado.config = () => {};
            ado.preview = () => {};
            ado.placement = () => {};
            ado.master = () => {};
            ado.slave = () => {};
        }

        ado.config({
            mode: 'new',
            xml: false,
            characterEncoding: true
        });
        ado.preview({
            enabled: true,
            emiter: 'ads.tvp.pl',
            id: 'y6g3tTbLJv6vLRZ.AfyeiXkCPM0gL3CNAik2rwTzhKD.N7'
        });

        // oflitrowanie reklam desktopowych adocean
        if (adsDesktop) {
            Object.keys(adsDesktop).forEach(() => {
                adocean.desktop = Object.keys(adsDesktop)
                    .filter(
                        key =>
                            adsDesktop[key].source &&
                            adsDesktop[key].source === 'ad_ocean'
                    )
                    .reduce((obj, key) => {
                        return Object.assign(obj, {
                            [key]: adsDesktop[key]
                        });
                    }, {});
            });
        }

        if (adsMobile) {
            // odfiltrowanie reklam mobilnych adocean
            Object.keys(adsMobile).forEach(() => {
                adocean.mobile = Object.keys(adsMobile)
                    .filter(
                        key =>
                            adsMobile[key].source &&
                            adsMobile[key].source === 'ad_ocean'
                    )
                    .reduce((obj, key) => {
                        return Object.assign(obj, {
                            [key]: adsMobile[key]
                        });
                    }, {});
            });
        }

        if (
            ado &&
            adocean.desktop &&
            window.innerWidth >= 992 &&
            master.desktop &&
            Object.keys(adocean.desktop).length
        ) {
            // ładowanie reklam desktopowych adocean
            if (adocean.desktop && adocean.desktop.wallpaper && adocean.desktop.wallpaper.id) {
                screeningDetect();
            }
            clearAdoceanSlots(adocean.desktop);
            initAdoceanSlots(adocean.desktop, master.desktop);
            betweenAdoceanModulesWatch(adocean.desktop, master.desktop);
        }

        if (
            ado &&
            adocean.mobile &&
            window.innerWidth < 992 &&
            master.mobile &&
            Object.keys(adocean.mobile).length
        ) {
            // załadowanie reklam mobilnych adocean
            clearAdoceanSlots(adocean.mobile);
            initAdoceanSlots(adocean.mobile, master.mobile);
            betweenAdoceanModulesWatch(adocean.mobile, master.mobile);
        }
    }

    const initAdoceanSlots = (adsData, master) => {
        ado.master({
            id: master,
            server: 'ads.tvp.pl'
        });

        if (adsData['wallpaper'] && document.querySelector(`.screening`)) {
            ado.slave(adsData['wallpaper'].id, {
                myMaster: master
            });
            document.querySelector(`.screening`).id = adsData['wallpaper'].id;
            document.querySelector('.screening').classList.add('ado', 'active-slot');
        }

        if (adsData['stickyad'] && document.querySelector(`.stickyad`)) {
            ado.slave(adsData['stickyad'].id, {
                myMaster: master
            });
            document.querySelector(`.stickyad`).id = adsData['stickyad'].id;
            document.querySelector('.stickyad').classList.add('ado', 'active-slot');
            stickyAdocenWatch();
        }

        if (adsData['interstitial'] && document.querySelector(`.interstitial`)) {
            ado.slave(adsData['interstitial'].id, {
                myMaster: master
            });
            document.querySelector(`.interstitial`).id = adsData['interstitial'].id;
            document.querySelector('.interstitial').classList.add('ado', 'active-slot');
            interstitialAdocenWatch();
        }

        if (adsData['belkaexpand'] && document.querySelector(`.belkaexpand`)) {
            ado.slave(adsData['belkaexpand'].id, {
                myMaster: master
            });
            document.querySelector('.belkaexpand').id = adsData['belkaexpand'].id; 
            document.querySelector('.belkaexpand').classList.add('ado', 'active-slot');
        }
    }

    const betweenAdoceanModules = (adsData, master) => {
        const top = document.querySelector('.top');
        const slider1 = document.querySelector('.slider1');
        const slider2 = document.querySelector('.slider2');
        const slider3 = document.querySelector('.slider3');
        const slider4 = document.querySelector('.slider4');
        const rectangle = document.querySelector('.rectangle');
        const brandingtop = document.querySelector('.brandingtop');
        // const brandingbottom = document.querySelector('.brandingbottom');

        if (top && adsData['top'] && !top.classList.contains('active-slot')) {
            initBetweenAdoceanModulesSlot('top', adsData, master);
            top.classList.add('ado', 'active-slot');
        }
        if (slider1 && adsData['slider1'] && !slider1.classList.contains('active-slot')) {
            initBetweenAdoceanModulesSlot('slider1', adsData, master);
            slider1.classList.add('ado', 'active-slot');
        }
        if (slider2 && adsData['slider2'] && !slider2.classList.contains('active-slot')) {
            initBetweenAdoceanModulesSlot('slider2', adsData, master);
            slider2.classList.add('ado', 'active-slot');
        }
        if (slider3 && adsData['slider3'] && !slider3.classList.contains('active-slot')) {
            initBetweenAdoceanModulesSlot('slider3', adsData, master);
            slider3.classList.add('ado', 'active-slot');
        }
        if (slider4 && adsData['slider4'] && !slider4.classList.contains('active-slot')) {
            initBetweenAdoceanModulesSlot('slider4', adsData, master);
            slider4.classList.add('ado', 'active-slot');
        }
        if (rectangle && adsData['rectangle'] && !rectangle.classList.contains('active-slot')) {
            initBetweenAdoceanModulesSlot('rectangle', adsData, master);
            rectangle.classList.add('ado', 'active-slot');
        }
        if (brandingtop && adsData['brandingtop'] && !brandingtop.classList.contains('active-slot')) {
            initBetweenAdoceanModulesSlot('brandingtop', adsData, master);
            brandingtop.classList.add('ado', 'active-slot');
        }
        // if (brandingbottom && adsData['brandingbottom'] && !brandingbottom.classList.contains('active-slot')) {
        //     initBetweenAdoceanModulesSlot('brandingbottom', adsData, master);
        //     brandingbottom.classList.add('ado', 'active-slot');
        // }
    }

    const betweenAdoceanModulesWatch = (adsData, master) => {
        // wykrywanie załadowania międzymodułowych slotów i odpalanie reklam
        betweenAdoceanModules(adsData, master)

        const callback = function(mutationsList) {
            // const activeSlots = document.querySelectorAll('.active-slot');

            // if(activeSlots && activeSlots.length === 5) {
            //     observer.disconnect();
            // }

            // if (activeSlots && activeSlots.length < 5) {
            //     betweenAdoceanModules(adsData, master)
            // }

            betweenAdoceanModules(adsData, master)

            return mutationsList;
        };

        observerAdoBeetweenModules = new MutationObserver(callback);

        observerAdoBeetweenModules.observe(document.querySelector('body'), {
            attributes: true,
            attributeFilter: ['style'],
            childList: true,
            subtree: true
        });
    }    

    const initBetweenAdoceanModulesSlot = (slotName, adsData, master) => {
		// console.log(slotName);
        document.querySelector(`.${slotName}`).id = adsData[slotName].id; 
        ado.slave(adsData[slotName].id, {
            myMaster: master
        });
    }

    const clearAdoceanSlots = (ads) => {
        Object.keys(ads).forEach(key => {
            let container = document.querySelector(`.${key}`);
            if (container && container.id && container.id !== ads[key].id && container.classList.contains('ado') && container.classList.contains('active-slot')) {
                container.removeAttribute('id');
                container.classList.remove('active-slot', 'ado');
                container.innerHTML = '';
            }
        });
    }

    const clearAds = () => {
        // console.log('clearing')
        const screening = document.querySelector('.screening.active-slot');
        const top = document.querySelector('.top.active-slot');
        const stickyad = document.querySelector('.stickyad__wrapper.loaded');

        // czyszczenie strony ze skryptów reklamowych adocean
        if (screening && window.gao && window.gao.bgim) {
            window.gao.bgim.cursorc = function() { return false;}
            window.gao.bgim.redirect = function() { return false;}
        }

        if (screening && screening.classList.contains('active-slot')) {
            screening.classList.remove('active-slot', 'ado', 'gam', 'screening--active');
            screening.style = '';
            screening.innerHTML = '';

            let screeningWrapper = document.querySelector('.screening__wrapper');

            if (screeningWrapper) {
                screeningWrapper.classList.remove('active-yes');
            }
        }

        if (top && top.classList.contains('active-slot')) {
            top.removeAttribute('id');
            top.setAttribute("id", "top");
            top.classList.remove('active-slot', 'ado', 'gam');
            top.style = '';
            top.innerHTML = '';
        }

        if (stickyad) {
            stickyad.classList.remove('loaded');
        }
    }

    const stickyAdocenWatch = () => {
        const callback = function(mutationsList) {
            if (document.querySelector('.stickyad').style.display !== 'none') {
                setTimeout(()=> {
                    if(document.querySelector('.stickyad__wrapper script[src="https://securepubads.g.doubleclick.net/tag/js/gpt.js"]')) {
                        if (document.querySelector('.stickyad__wrapper .loaded')) {
                            document.querySelector('.stickyad__wrapper').classList.add('loaded');
                            stickyAdoceanObserver.disconnect();
                        }
                    } else {
                        document.querySelector('.stickyad__wrapper').classList.add('loaded');
                        stickyAdoceanObserver.disconnect();
                    }
    
                }, 1000);
            }

            return mutationsList;
        };

        const stickyAdoceanObserver = new MutationObserver(callback);

        stickyAdoceanObserver.observe(document.querySelector('.stickyad'), {
            attributes: true,
            attributeFilter: ['style'],
            childList: true,
            subtree: true
        });
    }

    const interstitialAdocenWatch = () => {
        const that = this;
        let intAdoceanObserver = null;

        const callback = function(mutationsList) {
            if (
                document.querySelector('.interstitial').style.display !== 'none'
            ) {
                if (
                    (document.querySelector('.interstitial > div') &&
                        document.querySelector('.interstitial > div').style
                            .display !== 'none' &&
                        document.querySelector('.interstitial > div')
                            .offsetHeight) ||
                    (document.querySelector('.interstitial > a') &&
                        document.querySelector('.interstitial > a').style
                            .display !== 'none' &&
                        document.querySelector('.interstitial > a')
                            .offsetHeight)
                ) {
                    document
                        .querySelector('.interstitial__wrapper')
                        .classList.add('loaded');
                    interstitialAdoceanShow();
                    intAdoceanObserver.disconnect();
                } else if (
                    document.querySelectorAll('.interstitial > div') &&
                    document.querySelectorAll('.interstitial > div').length > 1
                ) {
                    const adsDiv = document.querySelectorAll(
                        '.interstitial > div'
                    )[1];

                    if (
                        adsDiv &&
                        adsDiv.style !== 'none' &&
                        adsDiv.offsetHeight
                    ) {
                        document
                            .querySelector('.interstitial__wrapper')
                            .classList.add('loaded');
                        interstitialAdoceanShow();
                        intAdoceanObserver.disconnect();
                    }
                }
            }

            return mutationsList;
        };

        intAdoceanObserver = new MutationObserver(callback);

        intAdoceanObserver.observe(document.querySelector('.interstitial'), {
            attributes: true,
            attributeFilter: ['style'],
            childList: true,
            subtree: true
        });
    }

    const interstitialAdoceanShow = () => {
        const isInterstitialLoaded = document.querySelector(
            '.interstitial__wrapper.loaded'
        );
        const progressbar = document.querySelector(
            '.interstitial__progressbar'
        );
        const counterWrapperText = document.querySelector(
            '.interstitial__counter-number'
        );

        isInterstitialLoaded.classList.add('show');

        let interstitialBtn = document.querySelector('.interstitial__btn');

        interstitialBtn.addEventListener('click', e => {
            isInterstitialLoaded.classList.remove('show');
        });

        const counterWrapper = document.querySelector('.interstitial__counter');
        if (counterWrapper) {
            let counter = 8;
            const counterInterval = setInterval(() => {
                counterWrapperText.innerText = counter;

                if (counter === 8) {
                    counterWrapper.classList.add('show');
                }

                if (counter === 0) {
                    clearInterval(counterInterval);

                    setTimeout(() => {
                        isInterstitialLoaded.classList.remove('show');
                    }, 500);
                }

                counter--;
            }, 1000);

            if (progressbar) {
                let width = 1;
                let progressInterval = null;

                progressInterval = setInterval(() => {
                    if (width >= 100) {
                        clearInterval(progressInterval);
                    } else {
                        width += 0.5;
                        progressbar.style.width = `${width}%`;
                    }
                }, 46);
            }
        }
    }
	
	const templateMessage = () => {
        window.addEventListener(
            'message',
            function(event) {
                const data = event.data;
                if (
                    event.origin === window.origin &&
                    typeof data === 'object' &&
                    data.type === 'setWallpaper'
                ) {
                    const el = document.querySelector('.screening');
                    if (!el) return;

                    el.style.backgroundImage = `url("${data.backgroundImage}")`;
                    el.style.backgroundRepeat = 'no-repeat';
                    el.style.backgroundPosition = `center ${data.top}`;
                    el.style.backgroundAttachment = data.bgAttachment;
                    el.style.backgroundColor = data.defaultColor;

                    document
                        .querySelector('.screening__wrapper')
                        .classList.add('active-yes');
                    document
                        .querySelector('.screening')
                        .classList.add('screening--active');

                    el.addEventListener('click', function() {
                        if (data.backgroundUrl && data.backgroundUrl !== '') {
                            window.open(data.backgroundUrl, '_blank');
                        }
                    });

                    el.addEventListener('mouseover', function() {
                        el.style.cursor = 'pointer';
                    });
                    el.addEventListener('mouseout', function() {
                        el.style.cursor = 'default';
                    });
                } else if (
                    event.origin === window.origin &&
                    typeof data === 'object' &&
                    data.type === 'setBrandingBackground'
                ) {
					// console.log('setBrandingBackground');
                    const el = document.querySelector('.brandingtop');
                    if (!el) {
                        return;
                    }
					// console.log(data);
                    if (data.slotsRefresh && Number(data.slotsRefresh) === 1) {
                        googletag.companionAds().setRefreshUnfilledSlots(true);
                    }

                    el.classList.add('loaded');
					
					['.article__player-wrapper', '.video-page__player']
					.forEach(selector => {
						const el = document.querySelector(selector);
						if (el) el.classList.add('branding');
					});
					
                    document
                        .querySelectorAll(
                            '.brandingtopspacer, .brandingbottomspacer'
                        )
                        .forEach(item => {
                            if (
                                data &&
                                typeof data.clickUrl === 'string' &&
                                data.clickUrl.trim() !== ''
                            ) {
                                item.setAttribute('href', data.clickUrl);
                                item.setAttribute('target', '_blank');
                                item.setAttribute('rel', 'noopener noreferrer');
                            }
                        });

                    el.style.backgroundImage = `url('${data.image}')`;
                }
            },
            false
        );
    }
}